import React, {useEffect, useState} from 'react';
import {DialogMUI, IconButtonMUI} from '../../../shared';
import {ReactComponent as LeftSVg} from '../../../assets/icons/left.svg';
import {ReactComponent as RightSvg} from '../../../assets/icons/right.svg';
import {ReactComponent as CloseSvg} from '../../../assets/icons/close.svg';
import ImageZoom from 'react-image-zooom';

const ImagesPopup = ({popupView, setPopupView}) => {
  const [currentFileIndex, setCurrentFileIndex] = useState(0);
  const itemWidth = 110;
  const dotsWidth = 24;
  const [translateX, setTranslateX] = useState(0);
  const [translateXMob, setTranslateXMob] = useState(0);

  const updateTranslateX = (index) => {
    if (popupView.files.length > 4) {
      const realIndex = index > 1 ? index - 2 : 0; // Skip the first thumbnail
      setTranslateX(-realIndex * itemWidth);
    }
  };

  const updateTranslateXDots = (index) => {
    if (popupView.files.length > 4) {
      const realIndex = index > 1 ? index - 2 : 0; // Skip the first thumbnail
      setTranslateXMob(-realIndex * dotsWidth);
    }
  };

  const showNextImage = () => {
    setCurrentFileIndex((prevIndex) => {
      const nextIndex = prevIndex === popupView.files.length - 1 ? 0 : prevIndex + 1;
      updateTranslateX(nextIndex);
      updateTranslateXDots(nextIndex);
      return nextIndex;
    });
  };

  const showPrevImage = () => {
    setCurrentFileIndex((prevIndex) => {
      const prevIndexAdjusted = prevIndex === 0 ? popupView.files.length - 1 : prevIndex - 1;
      updateTranslateX(prevIndexAdjusted);
      updateTranslateXDots(prevIndexAdjusted);
      return prevIndexAdjusted;
    });
  };

  const handleThumbnailClick = (index) => {
    setCurrentFileIndex(index);
    updateTranslateX(index);
    updateTranslateXDots(index);
  };

  let currentFile = popupView.visible && popupView.files.length ? popupView.files[currentFileIndex] : null;

  useEffect(() => {
    if (popupView.visible) {
      setCurrentFileIndex(popupView.index);
      updateTranslateX(popupView.index);
    }

    return () => {
      setCurrentFileIndex(0);
      setTranslateX(0);
    };
  }, [popupView.index, popupView.visible]);

  return (
    <DialogMUI
      open={popupView.visible}
      withoutDefaultWrapper={true}
      className={'mui-withoutBg'}
      fullScreen={true}
      maxWidth={'lg'}
    >
      {popupView.visible && (
        <div className='dialog-mui__wrapper'>
          <div
            className='dialog-mui__close'
            onClick={() => {
              setPopupView({
                files: [],
                type: 'photo',
                id: '',
                visible: false
              });
            }}
          >
            <CloseSvg />
          </div>
          {popupView.files.length > 1 && (
            <div className='dialog-mui__prev' onClick={showPrevImage}>
              <IconButtonMUI>
                <LeftSVg />
              </IconButtonMUI>
            </div>
          )}

          <div className='dialog-mui__image'>
            {popupView.type === 'photo' ? (
              <ImageZoom src={currentFile?.image?.main} alt={currentFile?.id} zoom='200' />
            ) : (
              // <img src={currentFile?.image?.main} alt={currentFile?.id} />
              <video controls={true} src={currentFile?.video} playsInline={true} autoPlay={true}></video>
            )}
          </div>
          {popupView.files.length > 1 && (
            <div className='dialog-mui__next' onClick={showNextImage}>
              <IconButtonMUI>
                <RightSvg />
              </IconButtonMUI>
            </div>
          )}

          <div className='dialog-mui__thumbnails'>
            <div className='dialog-mui__thumbnails-viewport' style={{transform: `translateX(${translateX}px)`}}>
              {popupView.type === 'photo' &&
                popupView.files.map((el, index) => {
                  return (
                    <div
                      onClick={() => handleThumbnailClick(index)}
                      key={el.id}
                      className={`dialog-mui__thumbnail ${currentFile?.id === el.id ? 'active' : ''}`}
                    >
                      <img src={el.image.thumbnail} alt='' />
                    </div>
                  );
                })}
            </div>
          </div>

          <div className='dialog-mui__thumbnails dialog-mui__thumbnails--mob'>
            <div className='dialog-mui__thumbnails-viewport' style={{transform: `translateX(${translateXMob}px)`}}>
              {popupView.type === 'photo' &&
                popupView.files.map((el, index) => {
                  return (
                    <div
                      onClick={() => handleThumbnailClick(index)}
                      key={el.id}
                      className={`dialog-mui__thumbnail ${currentFile?.id === el.id ? 'active' : ''}`}
                    ></div>
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </DialogMUI>
  );
};

export default ImagesPopup;
